import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import classNames from 'classnames'

class ProgressBar extends Component {
  static propTypes = {
    className: PropTypes.string,
    indeterminate: PropTypes.bool,
    text: PropTypes.string,
    translate: PropTypes.func.isRequired,
    percent: PropTypes.number,
  }

  render() {
    const {
      translate,
      percent = 0,
      indeterminate,
      text,
      className,
    } = this.props

    const cls = classNames(
      'progress-bar',
      'rounded',
      { indeterminate },
      className
    )

    const style = {
      width: `${indeterminate ? 100 : percent}%`,
    }

    const finalText = text || translate('loading')

    return (
      <div className={cls}>
        <span className='text'>{finalText}</span>

        <div className='progress-bar-progress' style={style}>
          <span className='progress-bar-progress-text text'>{finalText}</span>
        </div>
      </div>
    )
  }
}

export default translate(null, { wait: true, translateFuncName: 'translate' })(
  ProgressBar
)

export { ProgressBar }
